module.exports = __webpack_public_path__ + "static/media/kuti.3884977c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/kuti.jpeg
// module id = 537
// module chunks = 0